import z from 'zod/v4'
import { latLngSchema } from './types.ts'

export const locationSchema = z.object({
  id: z.string(),
  label: z.string(),
  coordinates: latLngSchema.optional(),
  postalCode: z.string(),
  countryName: z.string(),
  discriminator: z.string().optional(),
  distance: z.number().optional(),
  metadata: z
    .object({
      countryCode: z.string().optional(),
      providerCategory: z.string().optional(),
      providerId: z.string().optional(),
    })
    .optional(),
})

export type Location = z.infer<typeof locationSchema>

export const nearbyLocationSchema = locationSchema.extend({
  distance: z.number().optional(),
})

export type NearbyLocation = z.infer<typeof nearbyLocationSchema>
